<div id="dg-container" [style.width]="dgWidth" [style.height]="dgHeight">
	<div id="dg-header">
	  <div style="float: left;">
		<button mat-stroked-button style="line-height: 23px !important" type="button" (click)="clearFilters()">Filtreleri Temizle</button>
		<!-- <span class="button-group">
				<label>Available Undo's</label>
				<input id="undoInput" class="undo-redo-input" />
				<label>Available Redo's</label>
				<input id="redoInput" class="undo-redo-input" />
				<button id="undoBtn" class="undo-btn" (click)="undo()">Undo</button>
				<button id="redoBtn" class="redo-btn" (click)="redo()">Redo</button>
			  </span> -->
	  </div>
	  <div class="filterButtonGroup" *ngIf="hasStateButtons">
		<!-- <button (click)="restoreState()">Satır Kopyala</button>
			  <button (click)="restoreState()">Boş Satır Ekle</button>
			  <button (click)="restoreState()">Değişiklikleri Kaydet</button> -->
		<button mat-stroked-button type="button" (click)="restoreState()">Tablo Ayarlarını Yükle</button>
		<button mat-stroked-button type="button" (click)="resetState()">Tablo Ayarlarını Sıfırla</button>
		<button mat-stroked-button type="button" (click)="editColumns()">Tablo Ayarları</button>
	  </div>
	</div>
	<ag-grid-angular
	  #agGrid id="dataGrid"
	  style="width: 100%; height: 100%"
	  [ngClass]="theme"
	  [gridOptions]="gridOptions"
	  [rowData]="dataSource"
	  [columnDefs]="columnDefs"
	  [defaultColDef]="defaultColDef"
	  [localeText]="localeText"
	  [frameworkComponents]="frameworkComponents"
	  (sortChanged)="onGridSort($event)"
	  (filterModified)="onGridFilterModified($event)"
	  (filterChanged)="onGridFilter($event)"
	  (paginationChanged)="onPaginationChanged($event)"
	  (rowSelected)="onRowSelected($event)"
	  [debounceVerticalScrollbar]='true'
	  (selectionChanged)="onSelectionChanged($event)"
	  (firstDataRendered)="onFirstDataRendered($event)"
	  (cellValueChanged)="onCellValueChanged($event)"
	  (gridReady)="onGridReady($event)"
	  (columnResized)="onColumnResized($event)"
	  (columnVisible)="onColumnVisible($event)"
	  (columnMoved)="onColumnMoved($event)"
	  (cellDoubleClicked)="onCellDoubleClicked($event)"
	  [getContextMenuItems]="getContextMenuItems"
	  [sideBar]="sideBar"
	  [statusBar]="statusBar"
	  [defaultExportParams]="defaultExcelExportParams"
	  [excelStyles]="excelStyles"
	  [enableRangeSelection]="true"
	  [enableFillHandle]="true"
	  [undoRedoCellEditing]="true"
	  [undoRedoCellEditingLimit]="20"
	  [enableCellChangeFlash]="true"
	  [enableCharts]="enableCharts"
	  (rowDataChanged)="onRowDataChanged($event)"
	  [suppressCopyRowsToClipboard]="true"
	  ></ag-grid-angular>
	  <!--quickFilterText="deneme2"-->
	<div id="#dg-footer">
	  <div>
		<button mat-raised-button color="primary" (click)="selectedClicked()" type="button"
		  *ngIf="options['hasSelectButton']">{{"select"|translate}}</button>
		<button mat-raised-button [color]="dgButtonsInit.addBtnColor" (click)="addClicked()" type="button"
		  *ngIf="dgButtonsInit.hasAddBtn">
		  <mat-icon *ngIf="dgButtonsInit.addBtnIcon">{{dgButtonsInit.addBtnIcon}}</mat-icon>
		  {{dgButtonsInit.addBtnText|translate}}</button>
		<button mat-raised-button [color]="dgButtonsInit.editBtnColor" (click)="editClicked()" type="button"
		  *ngIf="dgButtonsInit.hasEditBtn" translate>
		  <mat-icon *ngIf="dgButtonsInit.editBtnIcon">{{dgButtonsInit.editBtnIcon}}</mat-icon>
		  {{dgButtonsInit.editBtnText|translate}} </button>
		<button mat-raised-button [color]="dgButtonsInit.deleteBtnColor" (click)="deleteClicked()" type="button"
		  *ngIf="dgButtonsInit.hasDeleteBtn" translate>
		  <mat-icon *ngIf="dgButtonsInit.deleteBtnIcon">{{dgButtonsInit.deleteBtnIcon}}</mat-icon>
		  {{dgButtonsInit.deleteBtnText|translate}} </button>
	  </div>
	</div>
  </div>
  